// reducers/patientsReducer.js
const initialState = {
    page: 0,
    rowsPerPage: 50,
};

const panelReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'UPDATE_PATIENTS_PAGE':
            return {
                ...state,
                page: action.payload
            };
        case 'UPDATE_PATIENTS_ROWS_PER_PAGE':
            return {
                ...state,
                rowsPerPage: action.payload
            };
        default:
            return state;
    }
};

export default panelReducer;
